const Created = "created";
const Quoted = "quoted";
const Success = "success";
const Failure = "failure";

const expected = "expected";
const newQuoted = "quoted_new";
const newCreated = "created_new";

const today = new Date();
const date = new Date("2024-08-09");

function all(): string[] {
  if (today > date) {
    return [expected, newQuoted, newCreated, Success, Failure];
  }

  return [Created, Quoted, Success, Failure];
}

export default {
  Created,
  Quoted,
  Success,
  Failure,
  all,
  expected,
  newQuoted,
  newCreated
};
